import { createBrowserRouter } from 'react-router-dom'
import { pathOverview, pathAlertView, pathExplorPlant, pathImpostazioni, pathNotification, pathPlanninng, pathMachineryFaultList, pathMachineryDocumentation, pathMachineryIntervention, pathMetriche, pathMachineryMetriche, subPathUsers, pathUser, subPathNewUser } from '../../configurations/setting'
import ErrorPage from '../../structures/root/errorPage';
import Root from '../../structures/root/root';
import ResearchMachine from '../../components/researchMachine/mainResearchMachine';
import Overview from '../../structures/overview/mainOverview';
import AlertViews from '../../structures/alertView/mainAlertView';
import Planning from '../../structures/planning/mainPlanning';
import SchedeExplorePlant from '../../structures/schedeExplorePlant/mainSchedereExplorePlant';
import MachineDetail from '../../structures/machineDetail/mainMachineDetail';
import SynopticPlant from '../../components/synopticPlant/mainSynopticPlant';
import MachineFaultList from '../../components/machineFaultList/mainMachineFaultList';
import MachineDocument from '../../components/machineDocument/mainMachineDocument';
import MachineryInterventions from '../../components/machineryInterventions/mainMachineryInterventions';
import Login from '../../components/login/mainLogin';
import MainMultiDonut from '../../components/multipleVariableDonut/mainMultiDonut';
import ProvaResponsive from '../../components/multipleVariableDonut/provaResponsive';
import TestModificaDiUnDato from '../../componentiTest/bottoneModificaIntervento/bottoneModifica';
import Metriche from '../metriche/mainMetriche';
import MachineMetriche from '../../components/machineMetriche/mainMachineMetriche';

import UserDetails from "../settings/subElements/mainUserDetails";
import NewUser from "../settings/subElements/mainNewUser";
import SettingsUsers from "../settings/mainSettingsUsers";
import Users from "../users/mainUsers";
import ComponeteProvaUtenti from '../../componentiTest/testUtenti/listaUtenti';


export const router = createBrowserRouter([

    {
        path: "/",
        element: <Root></Root>,
        errorElement: <ErrorPage></ErrorPage>,
        children: [

            {
                path: `${pathOverview}`,
                element: <Overview />
            },
            {
                path: `${pathAlertView}`,
                element: <AlertViews />
            },
            {
                path: `${pathExplorPlant}`,
                element: <SchedeExplorePlant />,
                children: [
                    {
                        path: `new`,
                        element: <ResearchMachine />
                    },
                    {
                        path: ``,
                        element: <ResearchMachine />
                    },
                    {
                        path: `:id`,
                        element: <MachineDetail />,
                        children: [
                            {
                                path: `${pathMachineryFaultList}`,
                                element: <MachineFaultList />
                            },
                            {
                                path: `${pathMachineryDocumentation}`,
                                element: <MachineDocument />
                            },
                            {
                                path: `${pathMachineryIntervention}`,
                                element: <MachineryInterventions />
                            },
                            {
                                path: `${pathMachineryMetriche}`,
                                element: <MachineMetriche />
                            }
                        ]
                    }
                ]
            },
            {
                path: `${pathPlanninng}`,
                element: <Planning />
            },
            {
                path: `${pathMetriche}`,
                element: <Metriche />
            },

            {
                path: `${pathNotification}`,
                element: <h1>Work in progress</h1>
            },
            {
                path: `${"/provaDonut"}`,
                element: <ProvaResponsive></ProvaResponsive>
            },
            {
                path: `${pathImpostazioni}/${subPathUsers}`,
                element: <SettingsUsers />
            },
            {
                path: `${pathImpostazioni}/${subPathUsers}/:iduser`,
                element: <UserDetails />
            },
            {
                path: `${pathImpostazioni}/${subPathNewUser}`,
                element: <NewUser />
            },
            {
                path: `${pathUser}`,
                element: <Users />
            },
            {
                path: `${pathImpostazioni}/${subPathUsers}`,
                element: <SettingsUsers />
            },
            {
                path: `ProvaUtenti`,
                element: <ComponeteProvaUtenti />
            }

        ]
    }

])